/**
 * client/src/pages/Login — Connexion
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * ─── POURQUOI ÇA PASSE PAR `AuthContext` ─────────────────────────────────────
 * Cette page appelait `axios` DIRECTEMENT et écrivait elle-même dans `localStorage`, sans jamais
 * prévenir `AuthContext`. Le jeton était donc bien stocké… mais l'état React (`user`,
 * `isAuthenticated`) restait vide. Conséquences, toutes observées :
 *
 *   - la navigation vers `/manage` retombait sur `/login`, car `ProtectedRoute` interroge le
 *     CONTEXTE — qui croyait l'utilisateur déconnecté ;
 *   - tout composant lisant `user` (bandeau « mot de passe par défaut », rôle, guichet assigné)
 *     ne voyait rien tant qu'on n'avait pas rechargé la page.
 *
 * Deux chemins de connexion, dont un qui ment à l'autre : la seule issue est qu'il n'y en ait
 * qu'un. `AuthContext.login()` fait déjà exactement ce qu'il faut — on l'appelle.
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/AuthContext';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // UN SEUL chemin de connexion : le contexte pose le jeton, l'en-tête axios ET l'état React.
      const res = await login(username, password);

      if (!res.success) {
        setError(res.error || 'Erreur de connexion. Veuillez vérifier vos identifiants.');
        return;
      }

      const { role, assignedCounterId, fullName, mustChangePassword } = res.user;
      toast.success(`Bienvenue, ${fullName}`);

      // Mot de passe par défaut encore en place : on emmène DIRECTEMENT à la page de changement.
      // Le laisser se débrouiller avec un bandeau, c'est accepter qu'il ne le fasse jamais.
      if (mustChangePassword) {
        navigate('/change-password');
        return;
      }

      if (role === 'admin' || role === 'manager') {
        navigate('/manage');
      } else if (role === 'agent' && assignedCounterId) {
        navigate('/counter');
      } else {
        navigate('/counter-select');
      }
    } catch (err) {
      setError(
        err.response?.data?.error || 
        'Erreur de connexion. Veuillez vérifier vos identifiants.'
      );
      toast.error('Échec de la connexion');
    } finally {
      setLoading(false);
    }
  };

  return (

    <div className="flex items-center justify-center min-h-screen bg-cover bg-center   "
     style={{ backgroundImage: "url('/images/login-fingerprint-bg.png')" }}
     >

    <div className="login-container">
  <div className="login-card logo-animated">
    <div className="login-header">
            <div className="p-6 bg-primary-500 text-white ">
                  <img 
                  src="/images/ticketflow-logo.png" 
                  alt="TicketFlow" 
                  className="mx-auto w-12 mb-2" />
                  <h1 className="text-2xl font-bold text-center">TicketFlow</h1>
                  <p className="text-center mt-1">Système de gestion de file d'attente</p>
             </div>
    </div>

    <form onSubmit={handleLogin} className="login-form">
      <h2>Connexion</h2>

      {error && <div className="login-error">{error}</div>}

      <div className="input-group">
        <label htmlFor="username">Nom d'utilisateur</label>
        <input id="username" type="text" value={username} onChange={e => setUsername(e.target.value)} required />
      </div>

      <div className="input-group">
        <label htmlFor="password">Mot de passe</label>
        <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
      </div>

      <button type="submit" className="login-button" disabled={loading}>
        {loading ? 'Connexion en cours…' : 'Se connecter'}
      </button>
    </form>
  </div>
</div>
</div>

    // // // <div className="flex items-center justify-center min-h-screen bg-gray-100">
    // // //   <div className="w-full max-w-md">
    // // //     <div className="bg-white rounded-lg shadow-lg overflow-hidden">
    // // //       <div className="p-6 bg-primary-500 text-white">
    // // //         <h1 className="text-2xl font-bold text-center">TicketFlow</h1>
    // // //         <p className="text-center mt-1">Système de gestion de file d'attente</p>
    // // //       </div>
          
    // // //       <form onSubmit={handleLogin} className="p-6 space-y-6">
    // // //         <h2 className="text-xl font-bold text-center text-gray-700 mb-6">Connexion</h2>
            
    // // //         {error && (
    // // //           <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
    // // //             <p>{error}</p>
    // // //           </div>
    // // //         )}
            
    // // //         <div>
    // // //           <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
    // // //             Nom d'utilisateur
    // // //           </label>
    // // //           <input
    // // //             id="username"
    // // //             type="text"
    // // //             value={username}
    // // //             onChange={(e) => setUsername(e.target.value)}
    // // //             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500"
    // // //             placeholder="Entrez votre nom d'utilisateur"
    // // //             required
    // // //           />
    // // //         </div>
            
    // // //         <div>
    // // //           <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
    // // //             Mot de passe
    // // //           </label>
    // // //           <input
    // // //             id="password"
    // // //             type="password"
    // // //             value={password}
    // // //             onChange={(e) => setPassword(e.target.value)}
    // // //             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500"
    // // //             placeholder="Entrez votre mot de passe"
    // // //             required
    // // //           />
    // // //         </div>
            
    // // //         <div>
    // // //           <button
    // // //             type="submit"
    // // //             disabled={loading}
    // // //             className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-500 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:bg-gray-400"
    // // //           >
    // // //             {loading ? 'Connexion en cours...' : 'Se connecter'}
    // // //           </button>
    // // //         </div>
    // // //       </form>
    // // //     </div>
    // // //   </div>
    // // // </div>
  );
};

export default LoginPage;
